import React from 'react';
export function WhyDifferent() {
  const reasons = ['Everything is organized in one beginner-friendly system', 'No jumping between scattered YouTube videos or blog posts', 'No complicated camera talk', 'No guessing what applies to your dog or situation', 'Designed specifically for dog owners using phones', 'Built for real-life moments, not perfect studio conditions'];
  return <section className="bg-warm-light py-16 md:py-24 px-4" data-id="element-333">
      <div className="max-w-3xl mx-auto" data-id="element-334">
        {/* Heading */}
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-center text-warm-hero mb-10 leading-tight" data-id="element-335">
          Why this works better than{' '}
          <span className="italic text-soft-gold" data-id="element-336">random free photo tips</span>
        </h2>

        {/* Reasons list */}
        <div className="bg-white p-8 md:p-10 rounded-2xl shadow-lg border border-soft-gold/15 mb-8" data-id="element-337">
          <ul className="space-y-5" data-id="element-338">
            {reasons.map((item, index) => <li key={index} className="flex items-start" data-id="element-339">
                <span className="text-green-500 mr-4 text-lg mt-0.5 flex-shrink-0" data-id="element-340">
                  ✅
                </span>
                <span className="font-sans text-lg text-gray-700" data-id="element-341">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Closing */}
        <p className="font-sans text-lg md:text-xl text-center text-gray-800 max-w-2xl mx-auto leading-relaxed" data-id="element-342">
          This is not just "photo advice." It's{' '}
          <span className="font-semibold text-warm-hero" data-id="element-343">
            a practical system you can actually use.
          </span>
        </p>
      </div>
    </section>;
}